import { ObjetKForm, requiredRule, combineRules } from '@siclop/kstone-vue'

export class ServiceTypeForm extends ObjetKForm {
  code: string = ''
  label: string = ''
  order: number = 0
  color: string = '#27ae60'
  defaultHourlyRate: number = 0
  description: string = ''

  static validationRules = {
    code: combineRules(requiredRule('Le code est obligatoire')),
    label: combineRules(requiredRule('Le libellé est obligatoire'))
  }

  constructor(data?: Partial<ServiceTypeForm>) {
    super(data)
    if (data) {
      this.code = data.code ?? ''
      this.label = data.label ?? ''
      this.order = data.order ?? 0
      this.color = data.color ?? '#27ae60'
      this.defaultHourlyRate = data.defaultHourlyRate ?? 0
      this.description = data.description ?? ''
    }
  }
}
